import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';

import { dayDateTimeState } from '@store';

import { TimeUtils } from '../helpers/TimeUtils';

type useGetExpireTimeTextArgs = {
  expireTimeUTC: number;
  issueTimeLocalTimeZone: string;
  isTodayTomorrowOrLater: string | null;
  tPath: string;
};

export const useGetExpireTimeText = ({
  expireTimeUTC,
  issueTimeLocalTimeZone,
  isTodayTomorrowOrLater,
  tPath,
}: useGetExpireTimeTextArgs) => {
  const { t } = useTranslation();
  const { timeZone } = useRecoilValue(dayDateTimeState);

  if (!expireTimeUTC || !issueTimeLocalTimeZone || !isTodayTomorrowOrLater || !timeZone) {
    return null;
  }
  const expireDate = TimeUtils.dateFromEpoch(expireTimeUTC);
  const expireTime = TimeUtils.getZonedTime(expireDate, timeZone, '12h');
  const monthDate = TimeUtils.getZonedDate(expireDate, timeZone);

  switch (isTodayTomorrowOrLater) {
    case 'today':
      return t(`${tPath}todayText`, { expireTime, issueTimeLocalTimeZone });
    case 'tomorrow':
      return t(`${tPath}tomorrowText`, { expireTime, issueTimeLocalTimeZone });
    case 'later':
      return t(`${tPath}laterText`, { monthDate });
    default:
      return '';
  }
};
